import React from 'react';
import { withTranslation } from 'react-i18next';
import WarningTriangle from '../../images/warning_triangle.png'
import VithroughPrompt from '../VithroughPopup/VithroughPopup'
import { Link } from "react-router-dom";
import './UserFileWarning.less'

class UserFileWarning extends React.Component {
    static defaultProps = {
        title: "",
        text: "",
        type: "none",
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    render() {
        const { t } = this.props;
        return (
            <div className='user_file_element_warning' onMouseEnter={(e) => this.setState({open: true})} onMouseLeave={(e) => this.setState({open: false})}>
            <div className='user_file_element_warning_link'>
                <Link title={t('Warning')} to="/faq">
                    <img alt={t('Warning')} src={WarningTriangle}/>
                </Link>
            </div>
            {this.state.open && <VithroughPrompt
                title={this.props.title || t('ModelTooBigTitle')}
                text={this.props.text || t('ModelTooBigText')}
                type="none"/>}
            </div>
            );
    }
}

export default withTranslation()(UserFileWarning);
